module.exports = __webpack_public_path__ + "static/media/Vitrinas-Publicitaria.b31b575e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Vitrinas-Publicitaria.jpg
// module id = 151
// module chunks = 0